<template>
    <div>
        <div v-if="!data.is_deleted">
            <div style="display: flex; justify-content: space-between">
                <el-checkbox v-model="data.multicarrier.enabled" :disabled="disabled"><h3>Multi-Carrier</h3></el-checkbox>
            </div>

            <div class="cd-section" style="display: flex; align-items: center; margin-left: 23px;">
                <span v-if="!data.multicarrier.estimate_dirty">
                    <span v-if="data.multicarrier.estimate_30day">
                        Estimated MC: {{ usNum(data.multicarrier.estimate_30day) }}/mo, {{ usNum(data.multicarrier.estimate_eom) }} by end of month
                    </span>
                    <span v-else>
                        No Estimate, see details for ballpark figures
                    </span>
                    <btn :click="showEstimates" icon="fa-fw fas fa-search"></btn>
                </span>
                <span v-else>
                    <i class="fa fa-pulse fa-spinner"></i> Refreshing Estimates
                </span>
            </div>

            <div class="cd-section" style="display: flex; align-items: center; margin-left: 23px;">
                Monthly budget
                <input type="number" class="form-control" style="width: 200px; margin: 0 15px;"
                       v-model="data.multicarrier.budget" :disabled="disabled"></input>
                CPL
                <input type="number" class="form-control" style="width: 75px; margin: 0 15px;"
                        v-model="data.multicarrier.cpl" :disabled="disabled"></input>
                <btn v-if="!disabled" icon="fas fa-level-down" :click="syncMCAppGoal"></btn>
            </div>

            <div class="cd-section">
                <div style="display: flex; align-items: center">
                    <el-checkbox v-model="data.multicarrier.app_goal_enabled" :disabled="disabled">Monthly lead goal</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.multicarrier.app_goal" :disabled="disabled"></input>
                    drivers per month
                </div>

                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.multicarrier.rollover_enabled" :disabled="disabled">Plus rollover</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.multicarrier.rollover" :disabled="disabled"></input>
                    leads from previous month
                </div>
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.daily_pacing.enabled" :disabled="disabled">Daily pacing</el-checkbox>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.multicarrier.daily_pacing.app_goal_enabled" :disabled="disabled">Day cap to</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.multicarrier.daily_pacing.app_goal" :disabled="disabled"></input>
                    drivers per day
                </div>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.multicarrier.daily_pacing.autopacing" :disabled="disabled">Automatic daily pacing</el-checkbox>
                </div>
                <div style="display: flex; align-items: center; margin-left: 60px;">
                    <el-checkbox v-model="data.multicarrier.daily_pacing.frontloading_enabled">MC delivery first 15 days</el-checkbox>
                    <div class="input-group"  style="width: 100px; margin: 0 15px;">
                        <input type="number" v-model="data.multicarrier.daily_pacing.frontloading_percent" class="form-control"></input>
                        <span class="input-group-addon">%</span>
                    </div>
                </div>
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.promoted" :disabled="disabled">MC Promoted</el-checkbox>
            </div>

            <div class="cd-section">
              <el-checkbox v-model="data.multicarrier.owner_operator" :disabled="disabled">Owner Operator MC</el-checkbox>
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.match_equipment_interest" :disabled="disabled">Exact match equipment interest</el-checkbox>
                ( <el-checkbox v-model="data.multicarrier.match_equipment_interest_undefined" :disabled="disabled">or undefined</el-checkbox> )
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.match_equipment_experience" :disabled="disabled">Exact match equipment experience</el-checkbox>
                ( <el-checkbox v-model="data.multicarrier.match_equipment_experience_undefined" :disabled="disabled">or undefined</el-checkbox> )
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.match_route" :disabled="disabled">Exact match route</el-checkbox>
                ( <el-checkbox v-model="data.multicarrier.match_route_undefined" :disabled="disabled">or undefined</el-checkbox> )
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.match_teams" :disabled="disabled">Exact match teams</el-checkbox>
                ( <el-checkbox v-model="data.multicarrier.match_teams_undefined" :disabled="disabled">or undefined</el-checkbox> )
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.match_twic" :disabled="disabled">Needs TWIC</el-checkbox>
            </div>

            <div class="cd-section">
                <el-checkbox v-model="data.multicarrier.filter_timeandday" :disabled="disabled">Time and day filter (deliver on the selected days and hours only)</el-checkbox>
            </div>

            <div class="row" style="margin-top: 20px;" v-if="data.multicarrier.filter_timeandday">
                <div class="col-sm-4">
                    <p><b>Hours</b></p>
                    <div class="my-2">
                        <el-checkbox-group v-model="data.multicarrier.filter_hours">
                            <el-checkbox v-for="(hour) in hours_left" :key="hour.id" :label="hour.id" class="d-block ml-0" :disabled="disabled">
                                {{ hour.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="col-sm-4">
                    <p>&nbsp;</p>
                    <div class="my-2">
                        <el-checkbox-group v-model="data.multicarrier.filter_hours">
                            <el-checkbox v-for="(hour) in hours_right" :key="hour.id" :label="hour.id" class="d-block ml-0" :disabled="disabled">
                                {{ hour.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>

                <div class="col-sm-4">
                    <p><b>Days</b></p>
                    <div class="my-2">
                        <el-checkbox-group v-model="data.multicarrier.filter_days">
                            <el-checkbox v-for="(day) in days" :key="day.id" :label="day.id" class="d-block ml-0" :disabled="disabled">
                                {{ day.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>

            <div style="margin-top: 20px;">
                <el-checkbox v-model="data.singlecarrier.enabled" :disabled="disabled"><h3>Direct</h3></el-checkbox>
            </div>

            <div class="cd-section" style="display: flex; align-items: center; margin-left: 23px;">
                Monthly budget
                <input type="number" class="form-control" style="width: 200px; margin: 0 15px;"
                       v-model="data.singlecarrier.budget" :disabled="disabled"></input>
                CPL
                <input type="number" class="form-control" style="width: 75px; margin: 0 15px;"
                       v-model="data.singlecarrier.cpl" :disabled="disabled"></input>
                <btn v-if="!disabled" icon="fas fa-level-down" :click="syncDirectAppGoal"></btn>
            </div>

            <div class="cd-section">
                <div style="display: flex; align-items: center">
                    <el-checkbox v-model="data.singlecarrier.app_goal_enabled" :disabled="disabled">Monthly lead goal</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.singlecarrier.app_goal" :disabled="disabled"></input>
                    drivers per month
                </div>

                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.rollover_enabled" :disabled="disabled">Plus rollover</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.singlecarrier.rollover" :disabled="disabled"></input>
                    leads from previous month
                </div>
            </div>
            <div class="cd-section">
                <el-checkbox v-model="data.singlecarrier.weekly_pacing.enabled" :disabled="disabled">Weekly pacing</el-checkbox>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.weekly_pacing.app_goal_enabled" :disabled="disabled">Week cap to</el-checkbox>
                    <input type="number" class="form-control" style="width: 60px; margin: 0 15px;"
                           v-model="data.singlecarrier.weekly_pacing.app_goal" :disabled="disabled"></input>
                    drivers per week
                </div>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.weekly_pacing.autopacing" :disabled="disabled">Automatic weekly pacing
                    </el-checkbox>
                </div>
            </div>

            <div style="margin-top: 20px;">
                <h3>Products</h3>
            </div>
            <div class="cd-section">
                <el-checkbox v-model="data.singlecarrier.products.job_board.enabled">Job Board</el-checkbox>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.products.job_board.promoted">Promoted</el-checkbox>
                </div>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.products.job_board.uncapped" :disabled="disabled">Uncapped Job Board</el-checkbox>
                </div>
            </div>
            <div class="cd-section">
                <el-checkbox v-model="data.singlecarrier.products.direct_calls.enabled">Twilio tracked calls
                </el-checkbox>
            </div>
            <div class="cd-section">
                <el-checkbox v-model="data.singlecarrier.products.deja.enabled">DEJA</el-checkbox>
                <div style="display: flex; align-items: center; margin-left: 30px;">
                    <el-checkbox v-model="data.singlecarrier.products.deja.live_transfer" >JA Live Transfers</el-checkbox>
                </div>
                <div style="text-align: center">
                    <btn cssClass="btn-sm btn-danger" icon="fas fa-times" :click="deleteOrder">Delete Campaign</btn>
                </div>
            </div>
        </div>

        <div v-if="data.is_deleted" style="text-align: center">
            <btn cssClass="btn-sm btn-primary" icon="fas fa-sync-alt" :click="restoreOrder">Restore Campaign</btn>
        </div>

        <budget-estimates
            :show="estimates_dialog_show"
            :campaign_id="estimates_dialog_campaign_id"
            @close="estimates_dialog_show = false;"
        ></budget-estimates>
    </div>
</template>

<script>
export default {
    props: [
        'data',
    ],
    data() {
        return {
            estimates_dialog_show: false,
            estimates_dialog_campaign_id: null,
            pusher: {
                all_users: null,
            },
            hours_left: [
                { id: "hour_0", name: "12am-1am" },
                { id: "hour_1", name: "1am-2am", },
                { id: "hour_2", name: "2am-3am", },
                { id: "hour_3", name: "3am-4am", },
                { id: "hour_4", name: "4am-5am", },
                { id: "hour_5", name: "5am-6am", },
                { id: "hour_6", name: "6am-7am", },
                { id: "hour_7", name: "7am-8am", },
                { id: "hour_8", name: "8am-9am", },
                { id: "hour_9", name: "9am-10am", },
                { id: "hour_10", name: "10am-11am", },
                { id: "hour_11", name: "11am-12pm", }
            ],
            hours_right: [
                { id: "hour_12", name: "12pm-1pm", },
                { id: "hour_13", name: "1pm-2pm", },
                { id: "hour_14", name: "2pm-3pm", },
                { id: "hour_15", name: "3pm-4pm", },
                { id: "hour_16", name: "4pm-5pm", },
                { id: "hour_17", name: "5pm-6pm", },
                { id: "hour_18", name: "6pm-7pm", },
                { id: "hour_19", name: "7pm-8pm", },
                { id: "hour_20", name: "8pm-9pm", },
                { id: "hour_21", name: "9pm-10pm", },
                { id: "hour_22", name: "10pm-11pm", },
                { id: "hour_23", name: "11pm-12am", }
            ],
            days: [
                { id: "day_monday", name: "Monday", },
                { id: "day_tuesday", name: "Tuesday", },
                { id: "day_wednesday", name: "Wednesday", },
                { id: "day_thursday", name: "Thursday", },
                { id: "day_friday", name: "Friday", },
                { id: "day_saturday", name: "Saturday", },
                { id: "day_sunday", name: "Sunday", },
            ]
        };
    },
    computed: {
        disabled() {
            return this.data.auto_app_goals;
        }
    },
    watch: {
        'data.multicarrier.budget'(value) {
            if (value === '') {
                this.data.multicarrier.app_goal = '';
                this.data.multicarrier.app_goal_enabled = false;
                this.data.multicarrier.enabled = false;
            }
        },
        'data.multicarrier.app_goal'() {
            let enabled = this.data.multicarrier.app_goal > 0;
            this.data.multicarrier.enabled = enabled;
            if (!enabled) this.data.multicarrier.budget = null;
            this.data.multicarrier.app_goal_enabled = enabled;
        },
        'data.multicarrier.app_goal_enabled'() {
            let enabled = this.data.multicarrier.app_goal_enabled;
            if (!enabled) {
                this.data.multicarrier.enabled = false;
            }
        },
        'data.singlecarrier.budget'(value) {
            if (value === '') {
                this.data.singlecarrier.app_goal = '';
                this.data.singlecarrier.app_goal_enabled = false;
                this.data.singlecarrier.enabled = false;
            }
        },
        'data.singlecarrier.app_goal'() {
            let enabled = this.data.singlecarrier.app_goal > 0;
            this.data.singlecarrier.enabled = enabled;
            if (!enabled) this.data.singlecarrier.budget = null;
            this.data.singlecarrier.app_goal_enabled = enabled;
        },
        // single carrier click - apply defaults;
        'data.singlecarrier.enabled'(value) {
            if (value
                && !this.data.singlecarrier.products.direct_calls.enabled
                && !this.data.singlecarrier.products.deja.enabled) {

                this.data.singlecarrier.products.direct_calls.enabled = true;
                this.data.singlecarrier.products.deja.enabled = true;
                this.data.singlecarrier.products.deja.live_transfer = true;
            }

            if (value) {
                this.data.singlecarrier.products.job_board.enabled = true;
            }

            if (!value) {
                this.data.singlecarrier.products.job_board.enabled = false;
                this.data.singlecarrier.products.job_board.promoted = false;
            }
        }
    },
    methods: {
        deleteOrder() {
            return axios.post(url(`admin/budget-order/${this.data.id}/remove`))
                .then(response => {
                    this.$emit('updated');
                });
        },
        restoreOrder() {
            return axios.post(url(`admin/budget-order/${this.data.id}/restore`))
                .then(response => {
                    this.$emit('updated');
                });
        },

        syncMCAppGoal() {
            this.data.multicarrier.app_goal = Math.ceil(this.data.multicarrier.budget / this.data.multicarrier.cpl);
        },
        syncDirectAppGoal() {
            this.data.singlecarrier.app_goal = Math.ceil(this.data.singlecarrier.budget / this.data.singlecarrier.cpl);
        },
        showEstimates() {
            this.estimates_dialog_show = true;
            this.estimates_dialog_campaign_id = this.data.campaign_id;
        }
    }
}
</script>

<style>
.cd-section {
    margin-top: 10px;
}
.all-disabled input {
}

</style>
